import { DatePicker } from 'antd';
import React, { useEffect, useState } from 'react'
import { Link } from 'react-router-dom'

import Select from "react-select";
import { editBorderDistrict } from '../auth/services/privateapicalling';
// import fileimage from "../../../public/assets/img/icons/file"
import borderDistrictData from '../pages/PanelEngineerForm/borderDistrict.json';
import { toast } from "react-toastify";

interface editprop {
    selectedDistrict:any;
    districtOptions: any;
    token:string;
    applicationId:string;
    onUpdate: () => void;
  }

const EditPanelBorderDistrictModal:React.FC<editprop> = ({selectedDistrict , districtOptions , token , applicationId , onUpdate}) => {
    
    const [selectedBorders, setSelectedBorders] = useState({
        borderDistricts: [],
      });
    const [isValid, setIsValid] = useState(false);
    const [isUpdated , setIsUpdated] = useState(false)
    const [isLoading, setIsLoading] = useState(false);
    const [borderDistrictOptions, setBorderDistrictOptions] = useState([]);  


    const getModalContainer = () => {
        const modalElement = document.getElementById('modal-datepicker');
        return modalElement ? modalElement : document.body; // Fallback to document.body if modalElement is null
    };
    const getModalContainer2 = () => {
        const modalElement = document.getElementById('modal_datepicker');
        return modalElement ? modalElement : document.body; // Fallback to document.body if modalElement is null
    };

    const handleEdit = async(e: React.MouseEvent) => {
        setIsLoading(true)
   
       
       try {
         const borderDepartmentIdentifier = selectedBorders.borderDistricts;
         const body = {
            borderDepartmentIdentifier: borderDepartmentIdentifier,

         }
         
         const res = await editBorderDistrict(body , token , applicationId);
        setIsLoading(false)

         if(res.success=true){
            setIsUpdated(true)
            onUpdate();
            toast.error("Border District Updated Successfully")
         }
       } catch (error) {
 
        setIsLoading(false)

       }
    }

      const handleBorderDistrict = (name: string, option: any | any[] | null) => {

   
    

    const dist:any = districtOptions.filter(data=>
      option.some((opt:any)=> opt.label == data.label)
    )
  
   

     setSelectedBorders((prev) => ({
    ...prev,
    [name]: dist.map(d => d.value),
  }));
   
  
  };

    
    useEffect(() => {
        setIsValid(true)
        },[isUpdated])


        useEffect(() => {
        

        const borderDistricts =
                borderDistrictData.find((d) => d?.District === selectedDistrict)?.["Border Districts"] || [];
        
          
                const borderOptions = borderDistricts.map((district) => ({
                  label: district,
                  value: district,
                }));
        
                
        
                setBorderDistrictOptions(borderOptions);

        },[selectedDistrict])

    return (
        <>
            {/* Add Activiy */}
            <div className="modal fade" id="editBorder">
                <div className="modal-dialog modal-dialog-centered modal-lg">
                    <div className="modal-content">
                        <div className="modal-header">
                            <h4 className="modal-title">Edit Border District</h4>
                            <button
                                type="button"
                                className="btn-close custom-btn-close"
                                data-bs-dismiss="modal"
                                aria-label="Close"
                            >
                                <i className="ti ti-x" />
                            </button>
                        </div>
                        <form>
                            <div className="modal-body pb-0">
                                <div className="row">
                            
                                <div className="col-md-6 mb-3">
                                    <label className="form-label">
                                    Border District <span className="text-danger">*</span>
                                    </label>
                                 
                                    <Select options={borderDistrictOptions}
                                     isMulti
                                    //  onChange={(selectedOptions) =>
                                    //     setSelectedBorders({
                                    //       borderDistricts: selectedOptions
                                    //         ? selectedOptions.map((opt) => opt.value)
                                    //         : [],
                                    //     })
                                    //   }
                                    onChange={(option) => handleBorderDistrict("borderDistricts", option)}
                                      placeholder="Select Border District" />
                                </div>

                                </div>
                            </div>

                            {/* Submit Button */}
                            <div className="modal-footer">
                                <button type="button" className="btn btn-light me-2" data-bs-dismiss="modal">
                                Cancel
                                </button>
                                <button type="button" className="btn btn-primary" onClick={handleEdit}  {...(isValid ? { "data-bs-dismiss" : "modal" } : {})} >
                                Edit
                                </button>
                            </div>
                        </form>
                    </div>
                </div>
            </div>
        
        </>


    )
}

export default EditPanelBorderDistrictModal
